// Blocks empty submits and limits each form to a single submission per page load.
// Each matched form gets its own `submitted` flag via closure.
// This is the same functionality as defined in media/js/app.js.
let isSubmitting = false;

export function isSearchSubmitting() {
  return isSubmitting;
}

export default function installSearchSubmitGuard($forms) {
  $forms.each(function() {
    const form = this;
    let submitted = false;
    $(form).on('submit', (e) => {
      const input = form.elements.q;
      const q = input ? String(input.value || '').trim() : '';
      if (submitted || !q) {
        e.preventDefault();
        return;
      }
      submitted = true;
      isSubmitting = true;
    });
  });
}
